import * as types from '../actions/types';
import { parseValue } from '../../utils/helpers';

const initialState = {
    data: [],
    columns: [],
    loading: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        /* Get main markets */
        case types.GET_MAIN_MARKETS_REQUEST:
            return { ...state, loading: true };
        case types.GET_MAIN_MARKETS_SUCCESS: {
            const mainMarkets = payload;
            let sortedOutcomes;
            let selectedIndex = 0;
            mainMarkets.forEach((market, i) => {
                market.specifierCodes = [];
                sortedOutcomes = market.outcomes.sort(function (a, b) {
                    a = parseValue(a.id);
                    b = parseValue(b.id);

                    // compare string part alphabetically
                    let result = a[0].localeCompare(b[0]);
                    // if the string part is the same, compare the number part
                    return result === 0 ? a[1] - b[1] : result;
                });
                if (market.specifiers.length > 0) {
                    market.specifiers.forEach(spc => {
                        market.specifierCodes.push(spc.name);
                    });
                }

                market.isSelected = selectedIndex < 3;
                market.selectedIndex = selectedIndex < 3 ? selectedIndex : -1;
                selectedIndex++;
                market.outcomes = sortedOutcomes;
            });
            return {
                ...state,
                loading: false,
                data: mainMarkets,
                columns: mainMarkets.map((market, index) => index).slice(0, 3),
            };
        }
        case types.CHANGE_SELECTED_MARKET:
            const { marketId, changedIndex } = payload;
            const updatedMarketSelections = [...state.data];
            updatedMarketSelections.forEach(item => {
                if (item.id === marketId) {
                    item['isSelected'] = true;
                    item['selectedIndex'] = changedIndex;
                } else if (item.selectedIndex === changedIndex) {
                    item['isSelected'] = false;
                    item['selectedIndex'] = -1;
                }
            });
            return { ...state, data: updatedMarketSelections };
        default:
            return state;
    }
}
